import { WorkRequirementConfirmationScreen } from "@/interactors/WorkRequirementConfirmationScreen";

export default function WorkRequirementConfirmation() {
  return <WorkRequirementConfirmationScreen />;
}
